import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoList from './components/VideoList';
import AppShell from './components/AppShell';
import VideoUpload from './components/VideoUpload';
import VideoPlayerWithSubtitles from './components/VideoPlayerWithSubtitles';
import Login from './components/Login';
import Register from './components/Register';
import MyPage from './components/MyPage';
import UserProfileEdit from './components/UserProfileEdit';
import ChangePassword from './components/ChangePassword';
import Settings from './components/Settings';
import ThemeEdit from './components/ThemeEdit';
import ContactUs from './components/ContactUs';
import RefreshPage from './components/RefreshPage';
// 暂时注释掉未使用的组件，后续可能需要
import VideoEdit from './components/VideoEdit';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { initViewportHeight } from './utils/viewportHeight';
import { initKuromoji } from './utils/kuromojiManager';
import './App.css';

// 初始化动态视口高度管理（智能：优先CSS方案，JS兜底）
initViewportHeight();

// 初始化 Kuromoji 分词器（全局单例，应用启动时初始化一次）
initKuromoji();

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <AppShell>
                    <VideoList />
                  </AppShell>
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <Layout>
                  <AppShell>
                    <VideoUpload />
                  </AppShell>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/player"
            element={
              <ProtectedRoute>
                <Layout showBottomNav={false}>
                  <VideoPlayerWithSubtitles />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <AppShell>
                    <MyPage />
                  </AppShell>
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/edit"
            element={
              <ProtectedRoute>
                <UserProfileEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/theme"
            element={
              <ProtectedRoute>
                <ThemeEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/refresh"
            element={
              <ProtectedRoute>
                <RefreshPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/settings/contact-us"
            element={
              <ProtectedRoute>
                <ContactUs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/video/edit"
            element={
              <ProtectedRoute>
                <VideoEdit />
              </ProtectedRoute>
            }
          />
          {/* 暂时隐藏的功能，后面再加回来 */}
          {/* <Route
            path="/history"
            element={
              <ProtectedRoute>
                <Layout>
                  <VideoHistory />
                </Layout>
              </ProtectedRoute>
            }
          /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
